/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções de gerenciamento dos dados da balística
 * @author Diego Sabino Amorim de Araújo
 * @file gerenciamentoBalisticaReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const CryptoJS = require('crypto-js')

const secretKey = '^~{9P8lnIg@V`f+Y0~TTTDRdg#;bvq'

const getInitialState = () => {
  let modeloInitialState = ''
  let itensBalisticosInitialState = []

  if (localStorage.getItem('@sigep/stateItensBalisticos')) {
    const bytes = CryptoJS.AES.decrypt(
      localStorage.getItem('@sigep/stateItensBalisticos'),
      secretKey
    )
    if (JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).modelo_balistico) {
      modeloInitialState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).modelo_balistico
    }
    if (JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).itensBalisticos) {
      itensBalisticosInitialState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).itensBalisticos
    }
  }

  const initialState = {
    itensBalisticos: itensBalisticosInitialState,
    processando: false,
    modelo_balistico: modeloInitialState,
  }
  return initialState
}

const initialState = getInitialState()

const gerenciamentoBalisticaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MODELO_BALISTICO: {
      const newState = {
        ...state,
        modelo_balistico: action.modeloBalistico,
      }

      localStorage.setItem(
        '@sigep/stateItensBalisticos',
        CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString()
      )

      return newState
    }

    case types.FETCH_ITENS_BALISTICOS_GERENCIAVEIS: {
      const newState = {
        ...state,
        itensBalisticos: action.itensBalisticos,
      }
      localStorage.setItem(
        '@sigep/stateItensBalisticos',
        CryptoJS.AES.encrypt(JSON.stringify(newState), secretKey).toString()
      )

      return newState
    }

    default: {
      return state
    }
  }
}

export default gerenciamentoBalisticaReducer
